(ns entities.risk-profile.events
  (:require
    [very.re-frame.core :as rf]
    [graphql.core :as qu]
    [entities.risk-profile.specs :as sp]))

(def path [:entities :risk-profile])

(rf/reg-entity
  :risk-profile
  {:get
   (fn [cfx]
     {:graphql {:gql (qu/risk-profile)
                :success [:risk-profile/fetched]
                :error [:risk-profile/fetch-errored]
                :cancellable? true}})

   :patch
   (fn [cfx [{:keys [data]}]]
     (let [profile (get-in (:db cfx) [:entities :risk-profile])]
       {:graphql {:gql (qu/update-risk-profile {:input data})
                  :success [:risk-profile/updated]
                  :error [:risk-profile/update-errored]}}))

   :spec/patch ::sp/patch
   })

(rf/reg-event-db
  :risk-profile/fetched
  (rf/path path)
  (fn [_ [data]]
    (get-in data [:client :risk-profile])))

(rf/reg-event-db
  :risk-profile/fetch-errored
  (rf/path path)
  (fn [_ [{:keys [data]}]]
    (get-in data [:client :risk-profile])))

(rf/reg-event-db
  :risk-profile/updated
  (rf/path path)
  (fn [_ [data]]
    (get-in data [:update-risk-profile])))

(rf/reg-event-db
  :risk-profile/update-errored
  (rf/path path)
  (fn [_ [{:keys [data]}]]
    (get-in data [:update-risk-profile])))

(rf/reg-sub
  :risk-profile/most-recent
  (fn [db]
    (last (get-in db path))))
